import { MultiStepFormState } from '@delmonicos/shared-design-system-react/src/contexts/multi-step-form-item';
import {
  MultiStepFormProvider,
  SubmitHandlerWithDirtyFields,
} from '@delmonicos/shared-design-system-react/src/contexts/multi-step-form.provider';
import { TriggerMessageModel } from '@delmonicos/shared-sdk/libs/cpms/src/libs/charge-hub-service-lib/src/wrapper/inputs/charge-point/ocpp/trigger-message.model';
import { SubmitErrorHandler } from 'react-hook-form';

import { useCreateChargePointOcppTriggerMessageContext } from '../../charge-point.context';
import { ChargePointOcppTriggerMessageCreateFormStep1Controller } from '../charge-point-ocpp-trigger-message-create-form-step-1/charge-point-ocpp-trigger-message-create-form-step-1.controller';

export interface ChargePointOcppTriggerMessageCreateFormControllerProps {
  onError: SubmitErrorHandler<
    Pick<
      TriggerMessageModel,
      'chargePointId' | 'requestedMessage' | 'physicalSocketId'
    >
  >;
  onSubmit: SubmitHandlerWithDirtyFields<
    Pick<
      TriggerMessageModel,
      'chargePointId' | 'requestedMessage' | 'physicalSocketId'
    >
  >;
  onCancel: () => void;
  state: MultiStepFormState;
}

export const ChargePointOcppTriggerMessageCreateFormController = (
  props: ChargePointOcppTriggerMessageCreateFormControllerProps,
): React.JSX.Element => {
  const { onError, onSubmit, onCancel, state } = props;
  const data = useCreateChargePointOcppTriggerMessageContext();

  return (
    <MultiStepFormProvider<
      Pick<
        TriggerMessageModel,
        'chargePointId' | 'requestedMessage' | 'physicalSocketId'
      >
    >
      useFormProps={{
        mode: 'all',
        defaultValues: data,
      }}
      submitErrorHandler={onError}
      submitHandler={onSubmit}
      onCancel={onCancel}
      state={state}
      items={[
        {
          fields: ['requestedMessage', 'physicalSocketId'],
          component: <ChargePointOcppTriggerMessageCreateFormStep1Controller />,
        },
      ]}
    />
  );
};
